function Logo() {
  return (
    <svg
      aria-hidden="true"
      width="40"
      height="25"
      viewBox="0 0 48 29"
      xmlns="http://www.w3.org/2000/svg"
      className="text-cyan-400 mt-1"
      style={{ transform: "scaleY(-1)" }} 
    >
      <defs>
        <clipPath id="monogram-clip">
          <path
            d="M0 0h6.5a6 6 0 0 1 5.2 3.1L19.4 17l4-9L19 0h6.5a6 6 0 0 1 5.2 3.1L39.5 19 35 29 24.5 10 16 29 0 0Zm46.7 2.8A2 2 0 0 0 45 0h-7l5.5 10 3.2-7.2Z"
            fill="currentColor"
          />
        </clipPath>
      </defs>
      <rect
        clipPath="url(#monogram-clip)"
        width="100%"
        height="100%"
        fill="currentColor"
      />
      <g clipPath="url(#monogram-clip)">
        <rect width="100%" height="100%" fill="currentColor" />
      </g>
    </svg>
  );
}

export default Logo;
